import { createContext, useContext } from 'react';
import { ListType } from 'modules/domains/list';

type FilterContextState = {
  search: string;
  type: ListType | null;
  setSearch: (search: string) => void;
  setType: (type: ListType | null) => void;
};

export const defaultState: FilterContextState = {
  search: '',
  type: null,
  setSearch: () => null,
  setType: () => null,
};

export const FilterContext = createContext<FilterContextState>(defaultState);

export const useFilterContext = () => useContext(FilterContext);
